import { Box, Button, Flex, Heading, SimpleGrid } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { Club } from '@/model';
import { AnthemFilters } from '../../types';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface AnthemFilterBoxProps {
  clubs: Club[];
  filtersForm: UseFormReturn<AnthemFilters>;
  forceRefetch: () => void;
}

export const AnthemFilterBox = ({ clubs, filtersForm }: AnthemFilterBoxProps) => {
  const { t } = useTranslation();
  const { reset } = filtersForm;

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_history_anthem.anthem_filter_box.anthem_filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_history_anthem.anthem_filter_box.anthem_filter_box_clear')}
        </Button>
      </Flex>
    </Box>
  );
};
